<template>
    <div class="editor">
        <div class="editor-header">
            <svg width="10px" height="10px" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M 6.221 1.668 L 8.253 3.712 L 3.107 8.888 L 1.073 6.843 Z M 9.796 1.176 L 8.89 0.264 C 8.539 -0.087 7.971 -0.087 7.619 0.264 L 6.751 1.138 L 8.783 3.181 L 9.796 2.162 C 10.068 1.89 10.068 1.448 9.796 1.176 Z M 0.005 9.717 C -0.032 9.885 0.119 10.035 0.286 9.993 L 2.555 9.441 L 0.526 7.396 Z"
                    fill="#fff"/>
            </svg>
            <span>Beitrag schreiben</span>
        </div>
        <div class="editor-body">
            <editor-content :editor="editor"/>

        </div>
        <div class="editor-images" v-if="showImages">
            <vue-dropzone ref="myVueDropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          @3vdropzone-sending="sendingEvent"
                          @vdropzone-complete="afterComplete"
                          @vdropzone-removed-file="removedFile"
                          @vdropzone-mounted="mountedDropzone"
            ></vue-dropzone>
        </div>
        <link-preview
            :preview-data="previewData"
            :preview-link="previewLink"
            :preview-stat="previewStat"
            :preview-show-slide="previewShowSlide"
            :preview-remove="removePreView">
        </link-preview>
        <div class="editor-images-original"
             v-if="originalData !== null && originalData.nfImages && originalData.nfImages.length > 0">
            <div class="editor-images-image" v-if="originalData.nfImages && originalData.nfImages.length < 2">
                <a :href="'media/user/' + image" v-for="(image, index) in originalData.nfImages" @click="blockLink"
                   :key="image">
                    <img :src="'media/user/' + image" v-if="getType(index, originalData) === 'image'">
                    <video width="100%" controls v-if="getType(index, originalData) === 'video'">
                        <source :src="'media/user/' + image+'#t=0.1'">
                        Your browser does not support the video tag.
                    </video>
                </a>
            </div>
            <div class="newsbox-thumbs" v-if="originalData.nfImages && originalData.nfImages.length > 1">
                <a :href="'media/user/' + image" v-for="image in originalData.nfImages" @click="blockLink"
                   :key="image" :style="{backgroundImage: 'url(media/user/' + image + ')'}">
                </a>
            </div>
        </div>

        <div class="newsoriginal" v-if="originalData !== null">
            <div class="newsoriginal--inner">
                <div class="newsoriginal__header">
                    <a class="no--padding image is--company" :href="'firma/' + originalData.udHash + '.html'"
                       v-if="originalData.udLogo && (originalData.udType === 0 || originalData.udType === '0')">
                        <div class="inner">
                            <img :src="'media/user/logos/' + originalData.udLogo">
                        </div>
                    </a>
                    <a class="no--padding image" :href="'Nutzer/' + originalData.udHash + '.html'"
                       v-if="originalData.udLogo && (originalData.udType === 1 || originalData.udType === '1')">
                        <div class="inner">
                            <img :src="'media/user/logos/' + originalData.udLogo">
                        </div>
                    </a>
                    <div class="text">
                        <a :href="'firma/' + originalData.udHash + '.html'"
                           v-if="originalData.udType === 0 || originalData.udType === '0'">
                            {{ originalData.udCompanyName }}
                        </a>
                        <a :href="'Nutzer/' + originalData.udHash + '.html'"
                           v-if="originalData.udType === 1 || originalData.udType === '1'">
                            {{ originalData.udFirstname }} {{ originalData.udSurname }}
                        </a>
                    </div>
                    <div class="action pull-right">
                        <button class="btn btn-secondary btn-simple" data-remove-follow="true"
                                :data-follow-id="originalData.udID"
                                v-if="originalData.isAbo === true">
                            <i class="kdz-icon icon-speech-bubble"></i>&nbsp;nicht mehr Folgen
                        </button>
                        <button class="btn btn-secondary btn-simple" data-add-follow="true"
                                :data-follow-id="originalData.udID"
                                v-if="originalData.isAbo === false">
                            <i class="kdz-icon icon-speech-bubble"></i>&nbsp;Folgen
                        </button>
                    </div>
                </div>
                <div class="newsoriginal-text" v-html="originalData.nfContent">
                </div>

            </div>
        </div>
        <div class="editor-footer">
            <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
                <div class="menubar">
                    <button class="menubar__button" @click="openEmoji(commands)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14.756" height="14.316"
                             viewBox="0 0 14.756 14.316">
                            <g transform="translate(0.44)">
                                <circle cx="7" cy="7" r="7" transform="translate(-0.44)" fill="#ffd93b"/>
                                <path
                                    d="M101.487,287.763a4.576,4.576,0,0,1-4.435-3.447.3.3,0,1,1,.578-.148,3.98,3.98,0,0,0,7.714,0,.3.3,0,0,1,.578.148A4.575,4.575,0,0,1,101.487,287.763Z"
                                    transform="translate(-94.329 -276.004)" fill="#3e4347"/>
                                <path
                                    d="M69.45,62.292a7.158,7.158,0,0,1-12.73,4.494A7.158,7.158,0,0,0,66.786,56.72,7.15,7.15,0,0,1,69.45,62.292Z"
                                    transform="translate(-55.134 -55.134)" fill="#f4c534"/>
                                <ellipse cx="1.097" cy="1.304" rx="1.097" ry="1.304" transform="translate(3.749 4.856)"
                                         fill="#3e4347"/>
                                <path
                                    d="M177.6,195.161a.236.236,0,0,1-.316-.075.2.2,0,1,1,.306-.251A.237.237,0,0,1,177.6,195.161Z"
                                    transform="translate(-172.258 -189.282)" fill="#5a5f63"/>
                                <ellipse cx="1.097" cy="1.304" rx="1.097" ry="1.304" transform="translate(8.374 4.856)"
                                         fill="#3e4347"/>
                                <path
                                    d="M342.959,195.161a.236.236,0,0,1-.316-.075.2.2,0,1,1,.306-.251A.237.237,0,0,1,342.959,195.161Z"
                                    transform="translate(-332.994 -189.282)" fill="#5a5f63"/>
                            </g>
                        </svg>
                        <span>Emoji</span>
                    </button>
                    <button class="menubar__button" @click="openImages" v-if="originalData === null">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16.356" height="12.395"
                             viewBox="0 0 16.356 12.395">
                            <path
                                d="M45.554,35.3v2.828A4.4,4.4,0,0,0,42.306,39.8l-1.458,1.23a.606.606,0,0,1-.773.01l-2.111-1.688a.6.6,0,0,0-.783.021l-2.276,1.919V35.3Zm0,0"
                                transform="translate(-33.791 -34.185)" fill="#c9d653"/>
                            <path
                                d="M40.852,160.038l1.458-1.23a4.184,4.184,0,0,0-.643,2.475,5.5,5.5,0,0,0,.084.965H34.906V160.3l2.276-1.916a.612.612,0,0,1,.783-.021l2.111,1.688A.611.611,0,0,0,40.852,160.038Zm0,0"
                                transform="translate(-33.791 -153.19)" fill="#00acea"/>
                            <path
                                d="M12.878.5V4.506a4.363,4.363,0,0,0-.832-.08c-.129,0-.259.007-.384.018V1.72H1.22V9.452H7.963a4.276,4.276,0,0,0,.444,1.213l-.01.007H0V.5Zm0,0"
                                transform="translate(0 -0.5)" fill="#032353"/>
                            <path
                                d="M242.35,124.065a4.341,4.341,0,0,1-.084-.86,4.308,4.308,0,0,1,3.926-4.289c.126-.01.255-.017.384-.017a4.307,4.307,0,1,1-3.779,6.376A4.121,4.121,0,0,1,242.35,124.065Zm0,0"
                                transform="translate(-234.527 -115.116)" fill="#fedb41"/>
                            <path d="M173.449,91.324a.993.993,0,1,1-1,.993A.992.992,0,0,1,173.449,91.324Zm0,0"
                                  transform="translate(-166.944 -88.423)" fill="#fedb41"/>
                            <path
                                d="M332.433,206.324h-.86v-.849a.35.35,0,0,0-.7,0v.849h-.825a.35.35,0,0,0,0,.7h.825v.849a.35.35,0,0,0,.7,0v-.849h.86a.35.35,0,0,0,0-.7Zm0,0"
                                transform="translate(-319.167 -198.588)" fill="#032353"/>
                        </svg>
                        <span>Foto/Video</span>
                    </button>
                    <button class="menubar__button is--post" @click="savePosting"><i class="zond-send"></i></button>
                </div>
            </editor-menu-bar>
            <div v-if="showEmoji" class="editor-emoji-picker" v-click-outside="hideEmoji">
                <VEmojiPicker @select="selectEmoji" :continuousList="true" />
            </div>
        </div>

        <div class="suggestion-list" v-show="showSuggestions" ref="suggestions">
            <template v-if="hasResults">
                <div
                    v-for="(user, index) in filteredUsers"
                    :key="user.id"
                    class="suggestion-list__item"
                    :class="{ 'is-selected': navigatedUserIndex === index }"
                    @click="selectUser(user)"
                >
                    <div class="image">
                        <img v-if="user.image" :src=user.image :alt=user.name>
                        <span v-else class="icon-camera"></span>
                    </div>
                    <div class="text">
                        {{ user.name }}
                        <span v-if="user.companyName" class="small"> <br>{{ user.companyName }}</span>
                    </div>
                </div>
            </template>
            <div v-else class="suggestion-list__item is-empty">
                Keine Nutzer gefunden
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Fuse from 'fuse.js';
import axios from 'axios';
import tippy from 'tippy.js';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import ClickOutside from 'vue-click-outside';
import {Editor, EditorContent, EditorMenuBar} from 'tiptap';
import {Placeholder, Link} from 'tiptap-extensions';
import {VEmojiPicker} from 'v-emoji-picker';
import LinkPreview from '@/components/LinkPreview';
import CustomMention from '@/extensions/Mention';
import Comment from './Comment';
import config from './config';
import notifier from './notifier';

function decodeEntities (encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
}
/* global $ */
export default {
    components: {
        LinkPreview,
        EditorMenuBar,
        EditorContent,
        VEmojiPicker,
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            // Create an `Editor` instance with some default content. The editor is
            // then passed to the `EditorContent` component as a `prop`
            newsFrom: '',
            newsChronik: '',
            newsId: '',
            previewData: null,
            previewStat: '',
            previewLink: '',
            previewShowSlide: false,
            showEmoji: false,
            showImages: false,
            query: null,
            suggestionRange: null,
            json: '',
            html: '',
            filteredUsers: [],
            navigatedUserIndex: 0,
            images: [],
            originalID: '',
            blockNewLink: false,
            originalData: null,
            insertMention: () => {
            },
            dropzoneOptions: {
                url: config().imageUploadUrl,
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                addRemoveLinks: true,
                maxFilesize: 100,
                timeout: 300000,
                dictDefaultMessage: '<i class=\'fas fa-cloud-upload\'></i> Laden Sie hier ihre Videos und Bilder hoch oder einfach per Drag & Drop hinzufügen'
            },
            observer: null,
            editor: new Editor({
                content: '',
                extensions: [
                    // The editor will accept paragraphs and headline elements as part of its document schema.
                    new Placeholder({
                        emptyNodeText: 'Jetzt einen Beitrag verfassen...',
                        emptyEditorClass: 'is-editor-empty',
                        emptyNodeClass: 'is-empty',
                        showOnlyWhenEditable: true,
                        showOnlyCurrent: true
                    }),
                    new Link({}),
                    new CustomMention({
                        matcher: {
                            allowSpaces: true
                        },
                        // a list of all suggested items
                        items: () => [],
                        // is called when a suggestion starts
                        onEnter: ({range, command}) => {
                            this.suggestionRange = range;
                            // we save the command for inserting a selected mention
                            // this allows us to call it inside of our custom popup
                            // via keyboard navigation and on click
                            this.insertMention = command;
                        },
                        // is called when a suggestion has changed
                        onChange: ({query, range, virtualNode}) => {
                            let _this = this;
                            if (query.length > 0) {
                                axios.post(config().api, {
                                    query: query,
                                    modus: 'searchUsersEditor'
                                })
                                    .then(function (response) {
                                        _this.query = query;
                                        _this.filteredUsers = response.data;
                                        _this.suggestionRange = range;
                                        _this.navigatedUserIndex = 0;
                                        _this.renderPopup(virtualNode);
                                    })
                                    .catch(function (error) {
                                        window.console.log(error);
                                    });

                            } else {
                                this.query = null;
                                this.filteredUsers = [];
                                this.suggestionRange = null;
                                this.navigatedUserIndex = 0;
                                this.destroyPopup();
                            }

                        },
                        // is called when a suggestion is cancelled
                        onExit: () => {
                            // reset all saved values
                            this.query = null;
                            this.filteredUsers = [];
                            this.suggestionRange = null;
                            this.navigatedUserIndex = 0;
                            this.destroyPopup();
                        },
                        // is called on every keyDown event while a suggestion is active
                        onKeyDown: ({event}) => {
                            if (event.keyCode === 38 || event.key === 'ArrowUp') {
                                this.upHandler();
                                return true;
                            }
                            // pressing down arrow
                            if (event.keyCode === 40 || event.key === 'ArrowDown') {
                                this.downHandler();
                                return true;
                            }
                            // pressing enter
                            if (event.keyCode === 13 || event.key === 'Enter') {
                                this.enterHandler();
                                return true;
                            }
                            return false;
                        },
                        // is called when a suggestion has changed
                        // this function is optional because there is basic filtering built-in
                        // you can overwrite it if you prefer your own filtering
                        // in this example we use fuse.js with support for fuzzy search
                        onFilter: (items, query) => {
                            if (!query) {
                                return items;
                            }
                            const fuse = new Fuse(items, {
                                tokenize: true,
                                threshold: 0.6,
                                keys: ['name']
                            });
                            return fuse.search(query);
                        }
                    })
                ],
                onUpdate: ({getHTML, getJSON}) => {
                    if (this.originalData !== null) {
                        this.json = getJSON();
                        this.html = getHTML();
                        return;
                    }
                    var links = decodeEntities(getHTML()).match(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g);
                    var _this = this;

                    if (this.previewLink === '' && links && links.length > 0 && links[0] !== _this.previewLink) {
                        _this.previewStat = 'pending';
                        _this.previewLink = links[0];
                        axios.post(config().api, {
                            link: links[0],
                            modus: 'getLinkPreview'
                        })
                            .then(function (response) {
                                if (typeof response.data === 'object' && response.data.length !== 0) {
                                    _this.setLinkPreview(response.data);
                                    _this.editor.setContent(_this.html.replace(/<a [^>]+>(.*?)<\/a>/, ''));
                                    // _this.editor.setContent(_this.html.replace(/<a [^>]+>(.*?)<\/a>/, '<a href="' + links[0] + '" rel="noreferrer noopener nofollow">' + response.data.title + '</a>'));
                                    _this.json = getJSON();
                                    _this.html = getHTML();
                                } else {
                                    _this.removePreView();
                                }
                            })
                            .catch(function (error) {
                                window.console.log(error);
                            });
                    } /*else if (!links || links.length === 0) {
                            // _this.removePreView();
                        }*/
                    this.json = getJSON();
                    this.html = getHTML();
                    // this.editor.setContent('Test');
                }
            })
        };
    },
    methods: {
        blockLink(e) {
            e.preventDefault()
        },
        getType (index, data) {
            if (!('imagesTypes' in data)) {
                return 'image';
            }
            if (!(index in data.imagesTypes)) {
                return 'image';
            }

            return data.imagesTypes[index];
        },
        mountedDropzone () {
            let _this = this;
            if (this.images.length) {
                $.each(this.images, function (key, value) { // eslint-disable-line
                    var file = {size: 0, name: value};
                    var url = 'media/user/' + value;
                    _this.$refs.myVueDropzone.manuallyAddFile(file, url);
                });
            }

        },
        hideEmoji () {
            if (this.showEmoji === true) {
                this.showEmoji = false;
            }

        },
        removedFile ({xhr, manuallyAdded, name}) {
            if (typeof xhr !== 'undefined') {
                let data = JSON.parse(xhr.response);
                this.images.splice(this.images.indexOf(data.fileName), 1);
            }
            if (manuallyAdded === true && typeof name !== 'undefined') {
                this.images.splice(this.images.indexOf(name), 1);
            }
        },
        afterComplete ({xhr}) {
            if (typeof xhr !== 'undefined') {
                let data = JSON.parse(xhr.response);
                this.images.push(data.fileName);
            }
        },
        sendingEvent (file, xhr, formData) {
            formData.append('modus', 'editorUploadFile');
        },
        setLinkPreview (data) {
            this.previewData = data;
            this.previewStat = 'show';
            let img = '';
            this.previewShowSlide = false;
            if (data.cover) {
                img = data.cover;
            } else if (typeof data.images === 'object') {
                let keys = Object.keys(data.images);
                img = data.images[keys[0]];
                this.previewShowSlide = keys.length > 1;
            }
            this.previewImage = img;
        },
        selectEmoji (emoji) {
            const transaction = this.editor.state.tr.insertText(emoji.data);
            this.editor.view.dispatch(transaction);
        },
        openEmoji () {
            this.showEmoji = !this.showEmoji;
        },
        // navigate to the previous item
        // if it's the first item, navigate to the last one
        upHandler () {
            this.navigatedUserIndex = ((this.navigatedUserIndex + this.filteredUsers.length) - 1) % this.filteredUsers.length;
        },
        // navigate to the next item
        // if it's the last item, navigate to the first one
        downHandler () {
            this.navigatedUserIndex = (this.navigatedUserIndex + 1) % this.filteredUsers.length;
        },
        enterHandler () {
            const user = this.filteredUsers[this.navigatedUserIndex];

            if (user) {
                this.selectUser(user);
            }
        },
        // we have to replace our suggestion text with a mention
        // so it's important to pass also the position of your suggestion text
        selectUser (user) {
            this.insertMention({
                range: this.suggestionRange,
                attrs: {
                    id: user.id,
                    label: user.name,
                    type: user.type
                }
            });
            this.editor.focus();
        },
        // renders a popup with suggestions
        // tiptap provides a virtualNode object for using popper.js (or tippy.js) for popups
        renderPopup (node) {
            if (this.popup) {
                return;
            }

            this.popup = tippy(node, {
                content: this.$refs.suggestions,
                trigger: 'mouseenter',
                interactive: true,
                theme: 'dark',
                placement: 'top-start',
                inertia: true,
                duration: [400, 200],
                showOnInit: true,
                arrow: true,
                arrowType: 'round'
            });

            // we have to update tippy whenever the DOM is updated
            if (MutationObserver) {
                this.observer = new MutationObserver(() => {
                    this.popup.popperInstance.scheduleUpdate();
                });
                this.observer.observe(this.$refs.suggestions, {
                    childList: true,
                    subtree: true,
                    characterData: true
                });
            }
        },
        destroyPopup () {
            if (this.popup) {
                this.popup.destroy();
                this.popup = null;
            }

            if (this.observer) {
                this.observer.disconnect();
            }
        },
        removePreView () {
            this.previewData = null;
            this.previewStat = '';
            this.previewLink = '';
            this.previewShowSlide = false;
        },
        savePosting () {
            let _this = this;
            if ($('#intern-teilen-news').length > 0 && $('#intern-teilen-news').hasClass('open')) {
                let fromChrionik = $('#internTeilenContactHash');
                if (fromChrionik.val() === '') {
                    notifier.show('', 'Bitte wählen Sie einen Kontakt aus', 'danger', '', 4000);
                    return;
                }
                this.newsFrom = fromChrionik.val();
                this.newsChronik = true;
            }

            axios.post(config().api, {
                linkData: {
                    ...this.previewData,
                    link: this.previewLink
                },
                images: this.images,
                newsHtml: this.html,
                newsID: this.newsId,
                newsFrom: this.newsFrom,
                newsChronik: this.newsChronik,
                newsOriginalId: this.originalID,
                modus: 'saveNewsPosting'
            })
                .then(function ({data}) {
                    if (data.status.type === 'success') {
                        if (data.update === true) {
                            $('#newsfeed-' + _this.newsId).find('.newsbox__content').html(data.html);  // eslint-disable-line
                            $('#news-change-modal').removeClass('open');
                            $('#modal-body-news').html('<div  id="newschange-main" class="newschange" data-id=""><div id="newschange"></div></div>');
                        } else if ($('#intern-teilen-newsfeed').length > 0 && $('#intern-teilen-newsfeed').hasClass('open')) {
                            let _modal = $('#intern-teilen-newsfeed');
                            let _modalBody = $('#modal-body-newsfeed-teilen');
                            _modal.removeClass('open');
                            _modalBody.html(' <div  id="newsfeed-teilen" class="newsfeed-teilen" data-link="" data-original-id=""><div id="newsfeed-teilen-inner"></div></div>');
                            notifier.show('', 'Der Beitrag wurde im Newsfeed geteilt', 'success', '', 4000);
                        } else if ($('#intern-teilen-news').length > 0 && $('#intern-teilen-news').hasClass('open')) {
                            let _modal = $('#intern-teilen-news');
                            let _modalBody = $('#modal-body-chronik-teilen');
                            _modal.removeClass('open');
                            _modalBody.html('<div  id="chronik-teilen" class="chronik-teilen" data-link="" data-original-id=""><div id="chronik-teilen-inner"></div></div>');
                            notifier.show('', 'Der Beitrag wurde in der Chronik geteilt', 'success', '', 4000);
                        } else {
                            $('#news-listing').prepend(data.html); // eslint-disable-line
                        }
                        $('body').removeClass('stop-scrolling');
                        _this.previewData = null;
                        _this.previewLink = '';
                        _this.images = [];
                        _this.closeImages();
                        _this.html = '';
                        _this.newsId = '';
                        _this.editor.clearContent(true);
                        _this.editor.focus();
                        _this.removePreView();
                        _this.showEmoji = false;
                        window.emojiPicker.discover();

                        if ($('.commenteditor').length > 0) { // eslint-disable-line
                            $('.commenteditor').each(function () { // eslint-disable-line
                                new Vue({
                                    render: h => h(Comment)
                                }).$mount(this);
                            });
                        }
                    } else {
                        notifier.show('', data.status.message, 'danger', '', 4000);
                    }
                })
                .catch(function (error) {
                    window.console.log(error);
                });
        },
        openImages () {
            this.showImages = !this.showImages;
        },
        closeImages () {
            this.showImages = false;
        },
        setDataMounted (_this, data, link) {
            if (typeof data.nfLinkData === 'object' && 'cover' in data.nfLinkData) {
                _this.previewData = {
                    cover: data.nfLinkData.cover,
                    images: data.nfLinkData.images,
                    title: data.nfLinkData.title,
                    description: data.nfLinkData.description,
                    video: data.nfLinkData.video,
                    videoType: data.nfLinkData.videoType
                };
                _this.previewStat = 'show';
                _this.setLinkPreview({
                    cover: data.nfLinkData.cover,
                    images: data.nfLinkData.images,
                    title: data.nfLinkData.title,
                    description: data.nfLinkData.description,
                    video: data.nfLinkData.video,
                    videoType: data.nfLinkData.videoType
                });
                _this.previewLink = link;
            }
            if (typeof data.nfImages !== 'undefined' && data.nfImages.length > 0) {
                _this.images = data.nfImages;
                _this.showImages = true;
            }
            _this.html = data.nfContent;
            _this.editor.setContent(data.nfContent);
        }
    },
    computed: {
        hasResults () {
            return this.filteredUsers.length;
        },
        showSuggestions () {
            return this.query || this.hasResults;
        }
    },

    beforeDestroy () {
        // Always destroy your editor instance when it's no longer needed
        this.editor.destroy();
    },
    mounted () {
        this.popupItem = this.$el;
        let newsId = $(this.$el).closest('.newschange').attr('data-id'); // eslint-disable-line
        let _this = this;


        if (typeof newsId !== 'undefined') {
            this.newsId = newsId;
            axios.post(config().api, {
                newsID: newsId,
                modus: 'getNews'
            })
                .then(function ({data}) {
                    if (typeof data.nfLinkData === 'object' && 'cover' in data.nfLinkData) {

                        _this.previewData = {
                            cover: data.nfLinkData.cover,
                            images: data.nfLinkData.images,
                            title: data.nfLinkData.title,
                            description: data.nfLinkData.description,
                            video: data.nfLinkData.video,
                            videoType: data.nfLinkData.videoType
                        };
                        _this.previewStat = 'show';
                        _this.setLinkPreview({
                            cover: data.nfLinkData.cover,
                            images: data.nfLinkData.images,
                            title: data.nfLinkData.title,
                            description: data.nfLinkData.description,
                            video: data.nfLinkData.video,
                            videoType: data.nfLinkData.videoType
                        });
                        _this.previewLink = data.nfLinkData.link;
                    }
                    if (data.nfImages.length > 0) {
                        _this.images = data.nfImages;
                        _this.showImages = true;
                    }
                    if (typeof data.originalData !== 'undefined') {
                        _this.originalData = data.originalData;
                    }
                    _this.html = data.nfContent;
                    _this.editor.setContent(data.nfContent);
                })
                .catch(function (error) {
                    window.console.log(error);
                });
        }

        let teilenLink = $('#newsfeed-teilen').attr('data-link'); // eslint-disable-line
        window.console.log(teilenLink);// eslint-disable-line
        if (typeof teilenLink !== 'undefined' && teilenLink !== '') {

            let originalId = $('#newsfeed-teilen').attr('data-original-id'); // eslint-disable-line
            if (typeof originalId !== 'undefined' && originalId !== '') {
                _this.originalID = originalId;
                _this.newsChronik = '';
                _this.newsFrom = '';
                axios.post(config().api, {
                    link: teilenLink,
                    originalID: originalId,
                    modus: 'getNewsTeilen'
                })
                    .then(function ({data}) {
                        _this.originalData = data.newsData;
                        _this.setDataMounted(_this, {
                            nfLinkData: data.newsData.nfLinkData
                        }, teilenLink);
                    })
                    .catch(function (error) {
                        window.console.log(error);
                    });
            } else {
                axios.post(config().api, {
                    link: teilenLink,
                    modus: 'getNewsfeedTeilen'
                })
                    .then(function ({data}) {
                        _this.setDataMounted(_this, data, teilenLink);
                        _this.html = data.nfContent;
                        _this.editor.setContent(data.nfContent);
                    })
                    .catch(function (error) {
                        window.console.log(error);
                    });
            }

        }


        let chronikLink = $('#chronik-teilen').attr('data-link'); // eslint-disable-line
        if (typeof chronikLink !== 'undefined' && chronikLink !== '') {
            let originalIdChronik = $('#chronik-teilen').attr('data-original-id'); // eslint-disable-line
            if (typeof originalIdChronik !== 'undefined' && originalIdChronik !== '') {
                _this.originalID = originalIdChronik;
                axios.post(config().api, {
                    link: chronikLink,
                    originalID: originalIdChronik,
                    modus: 'getNewsTeilen'
                })
                    .then(function ({data}) {
                        _this.originalData = data.newsData;
                        _this.setDataMounted(_this, {
                            nfLinkData: data.newsData.nfLinkData
                        }, chronikLink);
                    })
                    .catch(function (error) {
                        window.console.log(error);
                    });
            } else {
                axios.post('api.php', {
                    link: chronikLink,
                    modus: 'getNewsfeedTeilen'
                })
                    .then(function ({data}) {
                        _this.setDataMounted(_this, data, chronikLink);
                        _this.html = data.nfContent;
                        _this.editor.setContent(data.nfContent);
                    })
                    .catch(function (error) {
                        window.console.log(error);
                    });
            }
        }
        if (!teilenLink && !chronikLink) {
            let nutzerNews = $('#nutzer-news-editor');
            if (nutzerNews.length > 0) {
                this.newsFrom = nutzerNews.attr('data-from');
                this.newsChronik = parseInt(nutzerNews.attr('data-chronik'));
            }
        }


    },
    directives: {
        ClickOutside
    }
};
</script>

<style lang="scss">


</style>
